import script from "./CommonModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonModal.vue?vue&type=script&setup=true&lang=js"

import "./CommonModal.vue?vue&type=style&index=0&id=5cb8db1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb8db1b"]])

export default __exports__